import { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
import { aggiornamentiService, type RispostaDiretto } from '../../services/aggiornamentiService';

/**
 * "Aggiorna dal gestionale" sulle pagine admin di un dato: rilegge subito da
 * NTS con l'Aggiornamento diretto (`.scratch/aggiornamenti-erp/spec.md`) e poi
 * ricarica la pagina con `onFatto`.
 */
export function messaggioDiretto(r: RispostaDiretto, cosa: string): { tipo: 'success' | 'info' | 'error'; testo: string } {
  if (r.esito === 'ok') return { tipo: 'success', testo: `${cosa}: aggiornato dal gestionale` };
  if (r.esito === 'invariato') return { tipo: 'info', testo: r.errore ?? `${cosa} non presente sul gestionale: nessuna modifica effettuata.` };
  if (r.esito === 'busy') return { tipo: 'info', testo: `${cosa}: aggiornamento già in corso` };
  return { tipo: 'error', testo: r.errore ?? `${cosa}: aggiornamento non riuscito` };
}

export default function AggiornaDalGestionale({ numeroOrdine, onFatto, testId }: {
  numeroOrdine: string;
  onFatto: () => void | Promise<void>;
  testId?: string;
}) {
  const [inCorso, setInCorso] = useState(false);
  const aggiorna = async () => {
    setInCorso(true);
    try {
      const m = messaggioDiretto(await aggiornamentiService.direttoOrdine(numeroOrdine), `Ordine ${numeroOrdine}`);
      toast[m.tipo](m.testo);
      await onFatto();
    } catch {
      toast.error('Il gestionale non ha risposto: riprova fra qualche istante.');
    } finally {
      setInCorso(false);
    }
  };
  return (
    <button onClick={aggiorna} disabled={inCorso} data-testid={testId}
      className="h-9 px-3 rounded-lg border bg-white text-sm font-medium hover:bg-gray-50 transition-colors flex items-center gap-1.5 disabled:opacity-60">
      <RefreshCw className={`w-3.5 h-3.5 ${inCorso ? 'animate-spin' : ''}`} /> Aggiorna dal gestionale
    </button>
  );
}
